import { SubmissionError } from "redux-form";
import { HttpError, InternalServerError, ForbiddenError, NotAuthenticatedError, BadRequestError } from "Utils/http";

export default class SubmissionErrorWrapper {
  error: Error;

  constructor(error: Error) {
    this.error = error;
  }

  orRethrow() {
    throw this.error;
  }

  forHttpError(override: (...args: Array<any>) => any) {
    if (this.error instanceof HttpError) {
      if (typeof override === "function") {
        override(this.error);
      } else {
        throw new SubmissionError({
          _error: this.error.name,
          _status: this.error.statusCode,
        });
      }
    }

    return this;
  }

  forInternalServerError(override: (...args: Array<any>) => any) {
    if (this.error instanceof InternalServerError) {
      this.forHttpError(override);
    }

    return this;
  }

  forForbiddenError(override: (...args: Array<any>) => any) {
    if (this.error instanceof ForbiddenError) {
      this.forHttpError(override);
    }

    return this;
  }

  forNotAuthenticatedError(override: (...args: Array<any>) => any) {
    if (this.error instanceof NotAuthenticatedError) {
      this.forHttpError(override);
    }

    return this;
  }

  forBadRequestError(override: (...args: Array<any>) => any) {
    if (this.error instanceof BadRequestError) {
      if (typeof override === "function") {
        override(this.error);
      } else {
        throw new SubmissionError({
          _error: this.error.error,
          _status: this.error.statusCode,
          ...this.error.fieldErrors,
        });
      }
    }

    return this;
  }
}
